const cellulari = {
    state: {
        component: 'Index',
        edit: false,
        all: []
    },
    mutations: {
        CHANGE_CELLULARI_COMPONENT(state, payload) {
            state.component = payload
        },
        CHANGE_CELLULARI_EDIT(state, payload) {
            state.edit = payload
        }
    },
    getters: {
        getCellulariComponent: state => state.component,
        getCellulariEdit: state => state.edit
    }
}

export default cellulari